import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedUiCountdownModule } from '@fantaz/shared/ui/countdown';
import { TournamentCountdownComponent } from './countdown.component';

@NgModule({
  imports: [CommonModule, SharedUiCountdownModule],
  declarations: [TournamentCountdownComponent],
  exports: [TournamentCountdownComponent],
})
export class TournamentsUiCountdownModule {}
